export default __webpack_public_path__ + "static/media/i104hp.d885ea80.webp";